import { type FC } from "react";

import { PageLoader } from "@/components/ui";

/**
 * WithingsLoader - Spezialisierter Loader für Withings-Seiten
 *
 * Verwendet die globale PageLoader-Komponente mit Withings-spezifischen Einstellungen
 *
 * @returns {JSX.Element} Withings loader component
 *
 */
export const WithingsLoader: FC = () => (
  <PageLoader message="Lade Withings-Daten..." size="lg" withBackdrop />
);

/**
 * WithingsSyncLoader - Spezialisierter Loader für Withings-Sync-Vorgänge
 *
 * Zeigt einen professionellen Loader während der Synchronisation
 */
interface WithingsSyncLoaderProperties {
  message?: string;
  withBackdrop?: boolean;
}

export const WithingsSyncLoader: FC<WithingsSyncLoaderProperties> = ({
  message = "Synchronisiere Withings-Daten...",
  withBackdrop = true,
}) => <PageLoader message={message} size="lg" withBackdrop={withBackdrop} />;
